import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { generateBreadcrumbFromLocation } from "@/utils/generateBreadcrumbObjects";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useParams } from "react-router-dom";
import { useLanguage } from "@/hooks/useLanguage";

const RBreadcrumb = () => {
  const location = useLocation();
  const params = useParams();
  const { t } = useTranslation()
  const activeLanguage = useLanguage()
  const breadcrumbObjects = generateBreadcrumbFromLocation(location, params);
  const disabledKeyword: string[] = ["dashboard"]
  const filteredBreadcrumbs = breadcrumbObjects.filter(item => item.title !== "edit" && item.title !== "cms");

  const formatTitle = (title: string) => {
    return decodeURIComponent(title)
      .replace(/-/g, " ")
      .replace(/&amp;/g, "&")
      .replace(/&#38;/g, "&")
      .replace(/\+/g, " ");
  };

  return (
    <Breadcrumb>
      <BreadcrumbList>
        {filteredBreadcrumbs.map((breadcrumbItem, index) =>
          index != filteredBreadcrumbs.length - 1 ? (
            <>
              <BreadcrumbItem key={breadcrumbItem.title} className="hidden md:block text-foreground capitalize">
                {disabledKeyword.includes(breadcrumbItem.title) ?
                  <span>
                    {formatTitle(t(breadcrumbItem.title))}
                  </span> :
                  <Link to={breadcrumbItem.path}>{formatTitle(t(breadcrumbItem.title))}</Link>
                }
              </BreadcrumbItem>
              <BreadcrumbSeparator className="hidden md:block" lang={activeLanguage} />
            </>
          ) : (
            <BreadcrumbItem key={breadcrumbItem.title}>
              {breadcrumbItem.title != "undefined" &&
                <BreadcrumbPage className="!text-muted-foreground capitalize">
                  {formatTitle(t(breadcrumbItem.title))}
                </BreadcrumbPage>
              }
            </BreadcrumbItem>
          )
        )}
      </BreadcrumbList>
    </Breadcrumb>
  );
};

export default RBreadcrumb;